/* Accessible native scrolling with the live source's slide counts and disclosure. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => reduced.matches ? 'instant' : 'smooth';
  document.querySelectorAll('.nn-live-lower').forEach(surface => {
    surface.querySelectorAll('[data-live-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-live-track]');
      const prev = carousel.querySelector('[data-live-prev]');
      const next = carousel.querySelector('[data-live-next]');
      const dots = carousel.querySelector('[data-live-dots]');
      if (!track || !prev || !next) return;
      let dotCount = 0;
      const step = () => track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
      const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const update = () => {
        const visible = Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).gap)) / step()));
        const count = Math.max(1, track.children.length - visible + 1);
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max() - 2;
        if (!dots) return;
        dots.parentElement.hidden = max() < 2;
        if (count !== dotCount) {
          dots.replaceChildren(...Array.from({ length: count }, (_, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'nn-live-dot';
            button.setAttribute('aria-label', `Bekijk ingrediëntenpositie ${index + 1}`);
            button.addEventListener('click', () => track.scrollTo({ left: Math.min(index * step(), max()), behavior: behavior() }));
            return button;
          }));
          dotCount = count;
        }
        const active = Math.min(dotCount - 1, Math.round(track.scrollLeft / step()));
        [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
      };
      const move = direction => track.scrollBy({ left: direction * step(), behavior: behavior() });
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
    surface.querySelectorAll('[data-live-read-more]').forEach(button => {
      button.addEventListener('click', () => {
        const text = button.previousElementSibling;
        const expanded = text.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Lees minder' : 'Lees meer';
      });
    });
  });
})();
